import requestFunctions from "../../functions/requestFunctions";


export const state = {
  INTEGRATIONS_ITEM: {},
  INTEGRATIONS_LIST: [],
  INTEGRATIONS_TABLE_DATA: [],
  INTEGRATIONS_LIST_DATA: [],
  INTEGRATIONS_TOTAL_ROWS: 0
}

export const getters = {
  GET_INTEGRATIONS_ITEM: (state) => {
    return state.INTEGRATIONS_ITEM;
  },
  GET_INTEGRATIONS_LIST: (state) => {
    return state.INTEGRATIONS_LIST;
  },
  GET_INTEGRATIONS_TABLE_DATA: (state) => {
    return state.INTEGRATIONS_TABLE_DATA;
  },
  GET_INTEGRATIONS_LIST_DATA: (state) => {
    return state.INTEGRATIONS_LIST_DATA;
  },
  GET_INTEGRATIONS_TOTAL_ROWS: (state) => {
    return state.INTEGRATIONS_TOTAL_ROWS;
  }
}

export const mutations = {

  UPDATE_INTEGRATIONS_ITEM(state, item) {
    state.INTEGRATIONS_ITEM = item;
  },

  UPDATE_INTEGRATIONS_LIST(state, list) {
    
    state.INTEGRATIONS_LIST = list.data;

    state.INTEGRATIONS_TOTAL_ROWS = list.total;
    list = list.data;
    
    state.INTEGRATIONS_TABLE_DATA = [];
    state.INTEGRATIONS_LIST_DATA = [];

    list.forEach(el => {

      let status = el.status;

      if(status === 'enabled'){
        status = 'Включена';
      }

      if(status === 'disabled'){
        status = 'Выключена';
      }

      let fullname = '';

      if (el.profile_name3) { fullname = fullname + el.profile_name3 + ' '; }
      if (el.profile_name1) { fullname = fullname + el.profile_name1 + ' '; }
      if (el.profile_name2) { fullname = fullname + el.profile_name2 + ' '; }

      let acc_name = el.account_number;

      acc_name = el.user_phone;

      if (fullname !== '') {
        if (acc_name !== '') {
          acc_name = acc_name + ', ';
        }
        acc_name = acc_name + fullname;
      }

      state.INTEGRATIONS_TABLE_DATA.push({
        'name'   : el.name,
        'token'  : el.api_key,
        'account_number': acc_name,
        'uuid'   : el.uuid,
        'status' : status,
        'id': el.id,
        'created_at': el.created_at,
        'updated_at': el.updated_at,
      });

      state.INTEGRATIONS_LIST_DATA.push({
        id: el.id,
        uuid: el.uuid,
        name: el.name,
      });
    });
  },
}

export const actions = {

  async FETCH_INTEGRATIONS_ITEM({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/integrations/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_INTEGRATIONS_ITEM', response.data);
      return response.data;
    }

  },

  async FETCH_INTEGRATIONS_LIST({ commit }, payload= {}) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/integrations';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'GET');

    if(response.status !== 'success'){
      return false;
    } else {
      commit('UPDATE_INTEGRATIONS_LIST', response.data);
      return response.data;
    }

  },

  async FETCH_INTEGRATIONS_CREATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/integrations';

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'POST');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_INTEGRATIONS_UPDATE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/integrations/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'PUT');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

  async FETCH_INTEGRATIONS_DELETE({ commit }, payload) {

    let query_url = 'https://api.brendoss-finance.insistec.ru/v1/integrations/'+payload.uuid;

    let response = await requestFunctions.sendDataAsync(query_url, payload, 'DELETE');

    if(response.status !== 'success'){
      return false;
    } else {
      return response.data;
    }

  },

}